
<template>
    <v-container class="" style="padding: 6px;">
        <!-- >>> Resource was chosen: -------------------------------------- -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource !== undefined">
            <!-- >>> Left Side: -------------------------------------------- -->
            <v-col cols="6" md="3">
                <v-card class="pa-2" style="background-color: #fff;" outlined>
                    <table id="customers">
                        <thead>
                            <tr>
                                <th style="background-color: #CB67A0;">
                                    <v-card-title style="text-align: left; font-weight: 600; font-size: 14px; color: #fff;">
                                        <p>{{ get_flights_ResourceDetails_ResourceAskedFor.genLastname }}, {{ get_flights_ResourceDetails_ResourceAskedFor.genFirstName }}</p>
                                        <p>{{ get_flights_ResourceDetails_ResourceAskedFor.contractFunction }} in {{ get_flights_ResourceDetails_ResourceAskedFor.contractBaseStationCode }}, {{ get_flights_ResourceDetails_ResourceAskedFor.comPhone1 }}</p>
                                    </v-card-title>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </v-card>

                <v-card class="pa-2"  style="margin-top: 10px; background-color: #fff;" outlined>
                    <v-card-text>
                        <datetime v-model="startDate" label="Brief Date:" disabled="false" disabledTime="true" ref="startTimer" briefcaller="step7" />
                    </v-card-text>
                </v-card>

                <v-card class="pa-2" min-height="276" style="margin-top: 10px; background-color: #fff;" outlined>
                     <v-card-text>
                        <!-- >>> 'Flights this Day': ------------------------ -->
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="flightsThisDay.length > 0">Flights this Day:</span>
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="flightsThisDay.length === 0">No Flights this Day:</span>
                        <template v-for="(flight, index) in flightsThisDay">
                            <p style="font-size: 13px; font-weight: 500;" :key="index"><strong>{{ flight.flight }}:</strong> {{ flight.hours }} (LT), {{ flight.leg }}: {{ flight.ft }}h</p>
                        </template>

                        <!-- >>> 'Sectors': -------------------------------- -->
                        <br /><p style="font-size: 13px; font-weight: 500;" v-if="sectorsThisDay !== null"><strong>Sectors: </strong>{{ sectorsThisDay }}</p><br />

                        <!-- >>> 'Total FT/DT': ------------------------------- -->
                        <p style="font-size: 13px; font-weight: 500;">
                            <span v-if="totalFTThisDay !== null"><strong>FT Total: </strong>{{ totalFTThisDay }}, </span>
                            <span v-if="totalDTThisDay !== null"><strong>DT Total: </strong>{{ totalDTThisDay }}</span>
                        </p><br />

                        <!-- >>> 'Early & Co': ----------------------------- -->
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="earlynightsThisDay.length > 0">Early starts and night duties:</span>
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="earlynightsThisDay.length === 0">No Early starts and night duties:</span>
                        <template v-for="(item, index2) in earlynightsThisDay">
                            <p style="font-size: 13px; font-weight: 500;" :key="index2 + 100">
                                <strong>{{ item.date | dayjsFormatDate }}</strong>,
                                <template v-if="item.ESsectors > 0">early starts, </template>
                                <template v-if="item.LFsectors > 0">late finish, </template>
                                <template v-if="item.NDsectors > 0">night duty, </template>
                                {{ sectorsThisDay }} Sectors
                            </p>
                        </template>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- <<< Left Side: -------------------------------------------- -->


            <!-- >>> Right Side: ------------------------------------------- -->
            <v-col cols="12" sm="6" md="9">
                <!-- >>> Table: -------------------------------------------- -->
                <v-card class="pa-2" min-height="480" style="background-color: #fff;" outlined>
                    <table class="MyFlightTimeTable">
                        <tbody>
                            <tr>
                                <td class="header_cell" style="">&nbsp;</td>
                                <td class="header_cell" style="">01</td>
                                <td class="header_cell" style="">02</td>
                                <td class="header_cell" style="">03</td>
                                <td class="header_cell" style="">04</td>
                                <td class="header_cell" style="">05</td>
                                <td class="header_cell" style="">06</td>
                                <td class="header_cell" style="">07</td>
                                <td class="header_cell" style="">08</td>
                                <td class="header_cell" style="">09</td>
                                <td class="header_cell" style="">10</td>
                                <td class="header_cell" style="">11</td>
                                <td class="header_cell" style="">12</td>
                                <td class="header_cell" style="">13</td>
                                <td class="header_cell" style="">14</td>
                                <td class="header_cell" style="">15</td>
                                <td class="header_cell" style="">16</td>
                                <td class="header_cell" style="">17</td>
                                <td class="header_cell" style="">18</td>
                                <td class="header_cell" style="">19</td>
                                <td class="header_cell" style="">20</td>
                                <td class="header_cell" style="">21</td>
                                <td class="header_cell" style="">22</td>
                                <td class="header_cell" style="">23</td>
                                <td class="header_cell" style="">24</td>
                                <td class="header_cell" style="">25</td>
                                <td class="header_cell" style="">26</td>
                                <td class="header_cell" style="">27</td>
                                <td class="header_cell" style="">28</td>
                                <td class="header_cell" style="">29</td>
                                <td class="header_cell" style="">30</td>
                                <td class="header_cell" style="">31</td>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">jan</td>
                                <template v-for="(item, index) in yearlyList.january" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">feb</td>
                                <template v-for="(item, index) in yearlyList.february" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">mar</td>
                                <template v-for="(item, index) in yearlyList.march" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">apr</td>
                                <template v-for="(item, index) in yearlyList.april" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">may</td>
                                <template v-for="(item, index) in yearlyList.may" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">jun</td>
                                <template v-for="(item, index) in yearlyList.june" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">jul</td>
                                <template v-for="(item, index) in yearlyList.july" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">aug</td>
                                <template v-for="(item, index) in yearlyList.august" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">sep</td>
                                <template v-for="(item, index) in yearlyList.september" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">oct</td>
                                <template v-for="(item, index) in yearlyList.october" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">nov</td>
                                <template v-for="(item, index) in yearlyList.november" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                            <tr>
                                <td class="header_cell" style="">dec</td>
                                <template v-for="(item, index) in yearlyList.december" >
                                    <td class="cell_with_value" v-if="item.ESsectors !== 0" :key="index">ES</td>
                                    <td class="cell_with_value" v-else-if="item.LFsectors !== 0" :key="index">LF</td>
                                    <td class="cell_with_value" v-else-if="item.NDsectors !== 0" :key="index">ND</td>
                                    <td class="cell_empty" v-else :key="index">&nbsp;</td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                    <span style="font-size: 12px; font-weight: 500;">Early starts:</span><span style="font-size: 12pxem; font-weight: 400;"> duty starts between 05:00 - 05:59; </span>
                    <span style="font-size: 12px; font-weight: 500;">Late finish:</span><span style="font-size: 12pxem; font-weight: 400;"> duty ends between 23:00 - 01:59; </span>
                    <span style="font-size: 12px; font-weight: 500;">Night duty:</span><span style="font-size: 12pxem; font-weight: 400;"> duty overlaps with period between 02:00 - 04:59; </span>
                </v-card>
            </v-col>
            <!-- <<< Right Side: ------------------------------------------- -->
        </v-row>
        <!-- <<< Resource was chosen: -------------------------------------- -->




        <!-- >>> Resource was not chosen yet: ------------------------------ -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource === undefined">
            <v-col cols="12">
                <v-card class="pa-2" style="background-color: #fff;">
                    <v-card-title class="pa-4" style="color: #CB67A0; font-size: 15px; font-weight: 500;">
                        <i style="font-size:20px; color: #A4C2A5;" class="b-fa b-fa-check-circle"></i> Attention: Dear User, first select a resource in the upper area (click checkbox).
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <!-- <<< Resource was not chosen yet: ------------------------------ -->
    </v-container>
</template>

<script>
    import Datetime from '../../DateTime.vue';
    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';


    export default {
        name: 'Step7Content',

        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                startDate: new Date(), // today (See: watch{})
                // >>> --------------------------
                yearlyList: {},
                flightsThisDay: [],
                sectorsThisDay: null,
                totalFTThisDay: null,
                totalDTThisDay: null,
                earlynightsThisDay: [],
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /******************************************************************* Picker
            * watch::get_flights_CrewDetails_SavedPayload
            *
            * Desc: Monitor/Watch ... 'get_flights_CrewDetails_SavedPayload'.
            * Note:
            *
            */
            get_flights_CrewDetails_SavedPayload(v) {

                let me = this,
                    timestamp = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step7Content.vue >>> watch get_flights_CrewDetails_SavedPayload');
                if (v.date !== undefined) {
                    timestamp = new Date(v.date).setHours(23, 59, 0, 0);
                    this.startDate = new Date(timestamp);
                }

            }, // eo function get_flights_CrewDetails_SavedPayload()


            /*******************************************************************
            * watch::get_flights_ResourceDetails_EarlyNightDutiesYearlyList
            *
            * Desc: Monitor/Watch ... 'get_flights_ResourceDetails_EarlyNightDutiesYearlyList'.
            * Note:
            *
            */
            get_flights_ResourceDetails_EarlyNightDutiesYearlyList(v) {

                this.yearlyList = v;

            }, // eo function get_flights_ResourceDetails_EarlyNightDutiesYearlyList()


            /******************************************************************* Brief
            * watch::get_flights_BriefDetails_Flights_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Flights_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_Flights_ThisDay(v) {

                this.flightsThisDay = v;

            }, // eo function get_flights_BriefDetails_Flights_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_Sectors_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Sectors_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_Sectors_ThisDay(v) {

                this.sectorsThisDay = v;

            }, // eo function get_flights_BriefDetails_Sectors_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_TotalFT_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_TotalFT_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_TotalFT_ThisDay(v) {

                this.totalFTThisDay = v;

            }, // eo function get_flights_BriefDetails_TotalFT_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_TotalDT_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Sectors_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_TotalDT_ThisDay(v) {

                this.totalDTThisDay = v;

            }, // eo function get_flights_BriefDetails_TotalDT_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_EarlyNight_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_EarlyNight_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_EarlyNight_ThisDay(v) {

                this.earlynightsThisDay = v;

            }, // eo function get_flights_BriefDetails_EarlyNight_ThisDay()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails_SavedPayload',
                'get_flights_ResourceDetails_ResourceAskedFor',
                'get_flights_ResourceDetails_EarlyNightDutiesYearlyList',
                // ------------------------------
                'get_flights_BriefDetails_Flights_ThisDay',
                'get_flights_BriefDetails_Sectors_ThisDay',
                'get_flights_BriefDetails_TotalFT_ThisDay',
                'get_flights_BriefDetails_TotalDT_ThisDay',
                'get_flights_BriefDetails_EarlyNight_ThisDay',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step7Content.vue >>> created');
            eventBus.$on('onchangedatepickerbriefcall', this.onChange_DatePickerInBrief);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step7Content.vue >>> beforeDestroy');
            eventBus.$off('onchangedatepickerbriefcall', this.onChange_DatePickerInBrief);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_getCrewDetailsResourceBrief_Reload'
            ]),


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_DatePickerInBrief()
            *
            * Desc:
            * Desc:
            *
            * @param {String} value ()
            */
            onChange_DatePickerInBrief: function(values){

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step7Content.vue >>> onChange_DatePickerInBrief');
                if (values.caller === 'step7') {
                    me.actn_call_getCrewDetailsResourceBrief_Reload({ date: values.date });
                }

            }, // eo function onChange_DatePickerInBrief()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #customers {
        border-collapse: collapse;
        width: 100%;
    }

    #customers td, #customers th {
        border: 1px solid #ddd;
        padding: 8px;
        font-size: 13px;
    }

    #customers td {
        font-weight: 500 !important;
    }


    #customers tr:nth-child(even){background-color: #f2f2f2;}

    #customers tr:hover {background-color: #ddd;}

    #customers th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #A4C2A5;
        color: white;
        font-size: 14px;
        font-weight: 600 !important;
    }





    table.MyFlightTimeTable {
        background-color: #fff;
        width: 100%;
    }
    table.MyFlightTimeTable td {
        height: 25px;
        width: 31px;
        color: #fff;
        font-size: 13px;
        font-weight: 500;
        text-align: center;
    }
    table.MyFlightTimeTable .header_cell {
        background-color: #A4C2A5;
        color: #fff;
    }
    table.MyFlightTimeTable .cell_empty {
        background-color: #f3f4f5;
    }
    table.MyFlightTimeTable .cell_with_value {
        background-color: #CB67A0;

    }
</style>